module.exports = __webpack_public_path__ + "img/menu2.596c962d.png";